var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add_step_all flex flex--content--center",class:'add_step_all--count-' + _vm.stepsNumber},_vm._l((_vm.stepsNumber),function(step){return _c('div',{key:step,staticClass:"add_step",class:{ active: _vm.currentStep >= step }},[_vm._v(" "+_vm._s(step)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }